export interface ILocale {
  localeIdentifier: string;
  name: string;
}
export interface IMessageId {
  value: string;
}

export const defaultLocale: ILocale = {
  localeIdentifier: "en-US",
  name: "paris-common-property-defaultLocale"
};

export interface ILocalizationSettings {
  defaultLocaleIdentifiers: string[];
  messageIdProvider: {
    prefix: string;
  };
  messagePrefixes: string[];
}

export interface ILocalizable {
  messageId: IMessageId;
  tokens?: {};
}

export enum TranslationType {
  Info = "info",
  Warn = "warn",
  Error = "error",
  Option = "option",
  Action = "action",
  Filter = "filter",
  Property = "property",
  Nav = "nav",
  Heading = "heading",
  Summary = "summary",
  Tile = "tile",
  Badge = "badge",
  Title = "title"
}
